import { motion, animate } from "motion/react";
import { useEffect, useState, useRef } from "react";

const Estadisticas = ({clientes, contratos_completados}) => {
  const stats = [
    { label: "Clientes", value: 500 },
    { label: "Ahorradores", value: clientes },
    { label: "Ciudades", value: 5 },
    { label: "Contratos Completados", value: contratos_completados },
    { label: "Años de Experiencia", value: 4 },
  ];

  const [counts, setCounts] = useState(stats.map(() => 0));
  const sectionRef = useRef(null);

  // Función para iniciar animación de los contadores
  const startCount = () => {
    const animations = stats.map((stat, index) =>
      animate(0, stat.value, {
        duration: 2,
        onUpdate: (v) => {
          setCounts((prev) => {
            const newCounts = [...prev];
            newCounts[index] = Math.floor(v);
            return newCounts;
          });
        },
      })
    );

    return () => animations.forEach((a) => a.stop());
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            startCount();
          } else {
            // Reiniciamos los contadores al salir de la sección
            setCounts(stats.map(() => 0));
          }
        });
      },
      { threshold: 0.3 } // cuando el 30% de la sección esté visible
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <motion.div
      ref={sectionRef}
      className="container-fluid py-5 bg-white border-bottom"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: false, amount: 0.3 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
      id="trayectoria"
    >
      <div className="container text-center">
        {/* Título */}
        <motion.h2
          className="fw-bold mb-3"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.3 }}
          transition={{ duration: 0.6 }}
        >
          Nuestra Trayectoria
        </motion.h2>
        <motion.p
          className="mb-5"
          style={{ fontSize: "18px", color: "#555" }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          Estas son algunas de las cifras que reflejan nuestro compromiso y crecimiento en el sector financiero.
        </motion.p>

        {/* Estadísticas */}
        <div className="row d-flex justify-content-center">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              className="col-md-3 text-center m-3"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
            >
              <h2 style={{ fontSize: "48px", fontWeight: "bold", color: "#025a8c" }}>
                {counts[index]}+
              </h2>
              <p style={{ fontSize: "20px", fontWeight: "500" }}>{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default Estadisticas;
